import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'ep-template',
  template: `
    <p [innerHTML]= "getTemplate()"> </p>
 `,
})
export class EPTemplate extends FieldType {

  getTemplate() {
    var str = this.to.template;
    var tempArr = str.match(/\{{(.+?)\}}/g);
    tempArr.forEach(function (obj) {
      if (obj.indexOf('model') !== -1) {
        var tempObj = obj.replace('{{', "").replace('}}', "").replace('model', "this.model");
        try {
          str = str.replace(obj, eval(tempObj));
        }
        catch (e) {
          str = str.replace(obj, undefined);
        }
      }

    }.bind(this));
    return str;
  }
}
